import React, { useContext, useState } from 'react'

import { handleSchoolgrades } from '../../../services/BraveUp'
import DashboardComponents from '../dashboardComponents'
import { LocationContext } from '@BUP/contexts/LocationContext'

const ResultsDashboardComponentsMultiCourses = ({
  preAnalyticData,
  results,
  courses
}) => {
  const [courseId, setCourseId] = useState(null)
  const [loading, setLoading] = useState(false)
  const { locale } = useContext(LocationContext)

  const handleSelectCourse = courseId => {
    if (courseId) {
      setLoading(true)
      setCourseId(courseId)
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    } else {
      setCourseId(null)
    }
  }

  const courseGradeTags = courses[0].tags
  const nivel = courseGradeTags.find(ele => ele.includes('nivel'))
  const grades = handleSchoolgrades(locale)
  const sociogramCurrentGrade = grades.find(grade => grade.id === nivel)
  const name = sociogramCurrentGrade.name

  const filterPreAnalyticData = preAnalyticData.find(
    data => parseInt(data.courseId, 10) === courseId
  )

  const filterResults = results.find(
    result => parseInt(result.courseId, 10) === courseId
  )

  return (
    <DashboardComponents
      name={name}
      loading={loading}
      courses={courses}
      filterPreAnalyticData={filterPreAnalyticData}
      results={filterResults}
      handleSelectCourse={handleSelectCourse}
      courseId={courseId}
    />
  )
}

export default ResultsDashboardComponentsMultiCourses
